import React from 'react';
import OnePage from './Pages/Home';

function App() {
  return <OnePage />;
}

export default App;
